import React from 'react'

import { IMaskInput } from 'react-imask'
import classNames from 'classnames'
import { useField } from 'formik'

import { FieldError } from '@components/form'

import styles from '../../styles.module.scss'
import { FieldProps } from '@components/form/types'

type InputCpfProps = FieldProps & {
  id?: string
  className?: string
  placeholder?: string
  tabIndex?: number
  disabled?: boolean
  readOnly?: boolean
}

export const InputCpf = ({
  name,
  label,
  container,
  error,
  className,
  withoutError = false,
  ...rest
}: InputCpfProps) => {
  const [field, meta, helpers] = useField<string>(name)

  return (
    <div {...container}>
      {label}
      <IMaskInput
        mask="000.000.000-00"
        value={field.value}
        onAccept={(value: string) => helpers.setValue(value)}
        onBlur={() => helpers.setTouched(true)}
        className={classNames(styles.input, className, {
          [styles.error]: meta.error && meta.touched
        })}
        {...rest}
      />
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
